/* 2026-10-08 EXP-022 (new design): name-first mobile product page A/B + name prefill from ?name=.
   Markup, styles and variant assignment: snippets/ps-ab-namefirst.liquid (sets window.psAbNameFirst on phones only).
   1. Prefill (all viewports): /products/<handle>?name=Grace fills the Customer Canvas "first-name" field once it renders
      (Customer Canvas has no URL parameter of its own). Used by /pages/promises "Make her journal".
   2. A/B measurement (phones, real visitors only; not for ?ab= QA views or ?name= prefill views):
      - GA4 'ab_exposure' {ab_test:'pdp_namefirst', ab_variant:'a'|'b'} once the real name field has rendered (both arms),
        plus mirror events abnf_<v>_exposure / abnf_<v>_name_started / abnf_<v>_add_to_cart, so the per-variant rates can be
        read from the GA4 Data API without registering a custom dimension (sessions by eventName).
      - Hidden cart attribute _ab_pdp_namefirst = a|b (suffix _qa / _prefill when excluded), written when a cart already
        exists and again on Customer Canvas ADD TO CART (keepalive), so Shopify orders can be split.
   3. Variant b: the mirror input under the price writes into the real field with the native value setter + an input
      event (React picks it up; preview-cart-bar.js still fires personalization_name_started from the real field).
      "Preview" copies the name and taps the real Customer Canvas Preview button. The real field stays in place. */
(function () {
  var ab = window.psAbNameFirst || null;
  var NAME_RE = /[^A-Za-zÀ-ɏ' .\-]/g;
  var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;

  function real() { return document.querySelector('#ps-product-interface input[name="first-name"], input[name="first-name"]'); }
  function clean(v) { return String(v || '').replace(NAME_RE, '').replace(/\s+/g, ' ').replace(/^\s+/, '').slice(0, 16); }
  function writeReal(v) {
    var r = real();
    if (!r || r.value === v) return !!r;
    setter.call(r, v);
    r.dispatchEvent(new Event('input', { bubbles: true }));
    return true;
  }
  function ga(name, params) { try { if (window.psGa4Event) window.psGa4Event(name, params || {}); } catch (e) {} }
  function counted() { return ab && !ab.qa && !ab.prefill; }
  function attrValue() { return ab.variant + (ab.qa ? '_qa' : (ab.prefill ? '_prefill' : '')); }
  function setCartAttr(keepalive) {
    if (!ab) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: !!keepalive,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _ab_pdp_namefirst: attrValue() } })
      }).catch(function () {});
    } catch (e) {}
  }

  // Prefill from ?name= (letters only, max 16 like the real field).
  var pre = (window.location.search.match(/[?&]name=([^&#]*)/) || [])[1];
  if (pre) { try { pre = clean(decodeURIComponent(pre.replace(/\+/g, ' '))).trim(); } catch (e) { pre = ''; } }

  var mirror = document.getElementById('ps-abnf-input');
  var box = mirror && mirror.closest('[data-ps-abnf]');
  var showMirror = !!(ab && ab.variant === 'b' && box);

  if (showMirror) {
    if (pre) mirror.value = pre;
    mirror.addEventListener('input', function () {
      var v = clean(mirror.value);
      if (v !== mirror.value) mirror.value = v;
      box.classList.remove('is-error');
      writeReal(v);
    });
    var go = function () {
      var v = clean(mirror.value).trim();
      if (!v) { box.classList.add('is-error'); mirror.focus(); return; }
      writeReal(v);
      var tries = 0;
      (function tap() {
        var p = document.querySelector('#ps-product-interface button.ps-preview');
        if (p && !p.disabled) { p.click(); return; }
        if (++tries < 40) { setTimeout(tap, 250); return; }
        var r = real(); if (r) r.scrollIntoView({ block: 'center', behavior: 'smooth' });
      })();
    };
    box.querySelector('[data-ps-abnf-go]').addEventListener('click', go);
    mirror.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); mirror.blur(); go(); } });
  }

  // Wait for Customer Canvas to render the real field (async, up to ~30 s).
  var tries = 0;
  var iv = setInterval(function () {
    var r = real();
    if (!r) { if (++tries > 150) clearInterval(iv); return; }
    clearInterval(iv);
    var start = pre || (showMirror ? clean(mirror.value).trim() : '');
    if (start) writeReal(start);
    if (showMirror) {
      // Keep the mirror in step when the shopper edits the real field further down.
      document.addEventListener('input', function (e) {
        var t = e.target;
        if (t && t.name === 'first-name' && t !== mirror && mirror.value !== t.value && document.activeElement === t) mirror.value = t.value;
      }, true);
    }
    if (!ab) return;
    if (counted()) {
      ga('ab_exposure', { ab_test: ab.test, ab_variant: ab.variant });
      ga('abnf_' + ab.variant + '_exposure', {});
      var started = false;
      document.addEventListener('input', function (e) {
        var t = e.target;
        if (!started && t && t.name === 'first-name' && t !== mirror && String(t.value).trim()) {
          started = true;
          ga('abnf_' + ab.variant + '_name_started', {});
        }
      }, true);
    }
    if (/(?:^|;\s*)cart=/.test(document.cookie)) setCartAttr(false);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('#ps-product-interface .ps-finish');
      if (!b) return;
      if (counted()) ga('abnf_' + ab.variant + '_add_to_cart', {});
      // Never create a cart ourselves while Customer Canvas is adding (two carts could race for the cookie):
      // write the attribute only once the cart cookie exists, then once more after the add has settled.
      var n = 0;
      (function waitCart() {
        if (/(?:^|;\s*)cart=/.test(document.cookie)) { setCartAttr(true); setTimeout(function () { setCartAttr(true); }, 3000); return; }
        if (++n < 40) setTimeout(waitCart, 300);
      })();
    }, true);
  }, 200);
})();
